import { render, staticRenderFns } from "./TimetableEventCard.vue?vue&type=template&id=63a6fe08&scoped=true&"
import script from "./TimetableEventCard.vue?vue&type=script&lang=js&"
export * from "./TimetableEventCard.vue?vue&type=script&lang=js&"
import style0 from "./TimetableEventCard.vue?vue&type=style&index=0&id=63a6fe08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6fe08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VIcon,VImg})
